/**
 * @file 能力演示url
 */

export default {
    resumeAnalysis: {
        url: '/exp/demo/resumeAnalysis',
        method: 'post'
    },
    resumeAnalysisWord: {
        url: '/exp/demo/wordToPng',
        method: 'post'
    }
} as Record<string, NetTypes.Api>;
